import React from 'react'

export default (props)=>{

  return(
    <div className="opacity-50">
      <div className="d-block d-md-inline-block me-3">
        <small>
          Powered by
          <strong className="ms-1">
            <a href="https://depay.com" target="_blank" title="DePay" style={{ color: props.textColor }}>
              DePay
            </a>
          </strong>
        </small>
      </div>
      <div className="d-block d-md-inline-block">
        <a className="me-2" style={{ color: props.textColor }} href="https://depay.com/web3-payments" target="_blank"><small>Web3 Payments</small></a>
        <a className="ms-1 me-2" style={{ color: props.textColor }} href="https://depay.com/legal/terms" target="_blank"><small>Terms</small></a>
        <a className="ms-1 me-2" style={{ color: props.textColor }} href="https://depay.com/privacy" target="_blank"><small>Privacy</small></a>
        <a className="ms-1 me-md-2" style={{ color: props.textColor }} title="Report a problem or ask for help" href={`mailto:support@depay.com?subject=Problem with Link Payment ${props.link.id}`} target="_blank"><small>Help</small></a>
      </div>
    </div>
  )
}
